export const DATA_COLLECTION_ROUTE_ID_KEY = 'id';
export const DATA_COLLECTION_ROUTE_KEY = 'dataCollection';
export const DELIMITER_REGEX = /%/g;
export const FULL_KEY_REGEX = /%values\.\w+%/g;
export const KEY_REGEX = /^values\./;
export const MAIN_PAGE = 'inspections';
export const THROTTLE_TIMEOUT = 60000;
